<template>
  <!--srcviewscompanylistriskvuehtmlStart-->
  <div>
    <div
      id="defaultId1"
      class="uedbd2"
      style="display: flex; height: 100%; background: #f5f5f5"
    >
      <div
        style="overflow: hidden; transition: all 0.2s ease 0s; flex: 0 0 auto"
        :class="$store.state.app.isMenu ? '' : 'hidemenu'"
        v-loading="RiskLoding"
      >
        <div style="height: 99%; padding-bottom: 11%">
          <div :class="!this.Compare ? '' : 'vague'" style="height: 98%">
            <div class="left_menu margin-top30" style="height: 98%">
              <div class="FilterQuestion">
                <div class="left_menu_question">
                  <div class="table">
                    <div class="left_menu_context">
                      <p class="left_menu_context-title">
                        {{ $t("TradeByCountry.ImportExport") }}
                        <span class="Clear_all" @click="clearAllTags"
                          ><i
                            class="iconfont icon-qingchu"
                            style="color: #ff6a6a; margin-right: 5px"
                          ></i
                          >{{ $t("SearchTrade.ClearAll") }}</span
                        >
                      </p>
                      <el-radio-group
                        v-model="Improtradio"
                        @change="ChangeRadio"
                      >
                        <el-radio class="margin-bottom20" :label="0">{{
                          $t("TradeByCountry.ImportExport")
                        }}</el-radio>
                        <el-radio class="margin-bottom20" :label="1">{{
                          $t("SearchTrade.Imports")
                        }}</el-radio>
                        <el-radio :label="2">{{
                          $t("SearchTrade.Exports")
                        }}</el-radio>
                      </el-radio-group>
                    </div>

                    <div class="left_menu_context">
                      <p class="left_menu_context-title">
                        {{ $t("TradeByCountry.Company") }}
                      </p>

                      <el-select
                        :popper-append-to-body="false"
                        filterable
                        @change="ChangeRadio"
                        v-model="buyerNamevalue"
                        clearable
                        style="width: 100%"
                        :placeholder="$t('TradeByCountry.SelectCompanyName')"
                        class="search-select-con"
                      >
                        <el-option
                          v-for="item in buyerNameList"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                        >
                          <el-tooltip
                            effect="light"
                            :content="item.name"
                            placement="top"
                            :disabled="item?.name?.length < 24"
                          >
                            <span
                              style="
                                display: block;
                                max-width: 21rem;
                                line-height: auto;
                              "
                              class="Country_name"
                            >
                              {{ item.name }}</span
                            >
                          </el-tooltip>
                        </el-option>
                      </el-select>
                    </div>

                    <div class="left_menu_context">
                      <p class="left_menu_context-title">
                        {{ $t("TradeByCountry.ProductName") }}
                      </p>

                      <el-select
                        filterable
                        v-model="ProductName"
                        clearable
                        @change="ChangeRadio"
                        :popper-append-to-body="false"
                        style="width: 100%"
                        :placeholder="$t('TradeByCountry.SelectProductName')"
                        class="search-select-con"
                      >
                        <el-option
                          v-for="item in ProductNameList"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                        >
                          <el-tooltip
                            effect="light"
                            :content="item.name"
                            placement="top"
                            :disabled="item?.name?.length < 24"
                          >
                            <span
                              style="
                                display: block;
                                max-width: 21rem;
                                line-height: auto;
                              "
                              class="Country_name"
                            >
                              {{ item.name }}</span
                            >
                          </el-tooltip>
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="cc5f49"
        :class="
          $store.state.app.isMenu
            ? 'scrollbar scrollbar_right'
            : ' scrollbar scrollbar_right udb507two'
        "
      >
        <div style="height: 100%" v-loading="RiskLoding">
          <div class="list-label" v-show="!Compare" style="height: 100%">
            <div
              id="c6d65e"
              class="ub7918 Alchecked flex_center_bettwen"
              style="padding-left: 20px; align-items: center"
            >
              <div>
                <el-checkbox
                  v-if="isOpenSlct"
                  style="margin-right: 20px"
                  id="c0b733"
                  v-model="checked"
                  label
                  @change="changeSlctAll"
                  >{{ $t("TradeByCountry.All") }}</el-checkbox
                >
              </div>
            </div>
            <div
              class="flex_center_between_box"
              style="width: 100%; height: 98%"
            >
              <div class="risk-center-list">
                <div>
                  <h3 class="operations-head-content">
                    <div>
                      <span class="operations-headspan">{{
                        $t("TradeByCountry.ListofTradeCompanies")
                      }}</span>
                      <span class="tptitleSplit">|</span>
                      <span class="font18 total_companies font_bold"
                        >{{ $t("TradeByCountry.TotalCompanies") }}:
                        <span class="font_bold" style="color: #009ea7; margin-left: 5px;font-size: 20px;">{{ page.total | FilterNum }}</span></span
                      >
                    </div>
                  </h3>
                  <ul>
                    <draggable
                      filter=".forbid"
                      v-model="CompanyList"
                      :disabled="disabled"
                      animation="300"
                      :move="onMove"
                    >
                      <transition-group>
                        <li
                          v-for="(item, index) in CompanyList"
                          :key="index"
                          :class="
                            item.isDing
                              ? 'conpany-center-list forbid item'
                              : 'conpany-center-list item'
                          "
                          style="position: relative;"
                        >
                          <div
                            class="flex_between_box"
                            style="align-items: center"
                          >
                            <div class="conpany-center-list-left">
                              <el-checkbox
                                v-if="isOpenSlct"
                                id="cee084"
                                style="margin-right: 10px; margin-top: 0.3rem"
                                v-model="item.isChecked"
                                label
                                @change="changeItemChecked"
                              >
                              </el-checkbox>
                              <span
                                :class="
                                  item.isDing
                                    ? 'indexPositon'
                                    : 'indexPositonactive'
                                "
                                >{{ index + 1 }}</span
                              >
                              <div class="productContent">
                                <p class="productTitle">
                                  <span
                                    @click="exportCompanyImport(item)"
                                    class="CountryActive"
                                    style="
                                      font-family: 'Arial Bold';
                                      cursor: pointer;
                                      white-space: nowrap;
                                      overflow: hidden;
                                      text-overflow: ellipsis;
                                      max-width: calc(100% - 230px);
                                    "
                                    :class="{
                                      overexperise: NationalIndustryShow,
                                    }"
                                    >{{ item.companyName }}</span
                                  >

                                  <span class="margin20">
                                    <svg
                                      t="1728813835525"
                                      class="icon"
                                      viewBox="0 0 1075 1024"
                                      version="1.1"
                                      xmlns="http://www.w3.org/2000/svg"
                                      p-id="12745"
                                      width="1.8571428571428572rem"
                                      height="1.7142857142857142rem"
                                    >
                                      <path
                                        d="M273.757233 1023.872016a111.269069 111.269069 0 0 1-65.092533-21.142915 108.632604 108.632604 0 0 1-44.000812-107.378363l36.091416-208.459925c2.815642-16.074759-2.559675-32.379888-14.282986-43.591264l-0.102387-0.127984-152.863786-147.718839a108.58141 108.58141 0 0 1-28.054037-112.44652 109.835651 109.835651 0 0 1 89.358251-74.768104l211.249971-30.306551A49.836871 49.836871 0 0 0 343.610761 250.85019l94.477602-189.646315A110.168409 110.168409 0 0 1 537.454943 0.002048c42.413813 0 80.578567 23.421026 99.340984 61.227424l94.452005 189.646315c7.218283 14.48776 21.245302 24.624073 37.576027 27.055764l211.249972 30.434535a110.040425 110.040425 0 0 1 89.486235 74.742507 108.325443 108.325443 0 0 1-28.054037 112.472116l-152.863787 147.590856a49.504113 49.504113 0 0 0-14.385373 43.719248l36.091417 208.357538a108.607007 108.607007 0 0 1-44.128796 107.378363 110.731537 110.731537 0 0 1-116.541999 8.318944l-188.955203-98.445098a49.862467 49.862467 0 0 0-46.330116 0l-188.929606 98.445098a110.321989 110.321989 0 0 1-51.705433 12.926358z"
                                        :fill="
                                          item.isFavorite
                                            ? '#F56B6B'
                                            : '#CCCCCC'
                                        "
                                        p-id="12746"
                                      ></path>
                                    </svg>
                                  </span>
                                  <span
                                    class="margin20 IElabel"
                                    :class="
                                      value == 'Export' ? 'IElabelExport' : ''
                                    "
                                    v-for="(value, index) in item?.tagList"
                                    :key="index"
                                  >
                                    {{ value }}
                                  </span>

                                  <!-- <span class="margin-left20">
                                    <i
                                      class="iconfont icon-a-lujingbeifen251 icontransform"
                                      :class="{ rotate: item.isRotated }"
                                      @click="
                                        !NationalIndustryShow &&
                                          getCompanyDetailList(item, index)
                                      "
                                    ></i>
                                  </span> -->
                                </p>

                                <p
                                  class="list-text-color"
                                  style="color: #29445d !important"
                                >
                                  <img :src="item.flag" />{{ item.countryName }}
                                </p>
                                <p
                                  v-if="item.countryCode == 'CN'"
                                  class="list-text-color"
                                >
                                  {{ $t("TradeByCountry.CompanyID") }}:
                                  <span>
                                    {{ item.website ? item.regno : "-" }}
                                  </span>
                                </p>
                                <p v-else class="list-text-color">
                                  <span class="font666666">
                                    {{ $t("TradeByCountry.CompanyID") }}:</span
                                  >
                                  <span>
                                    {{ item.website ? item.regno : "-" }}
                                  </span>
                                  <span class="fontDDDDDD margin-left10"
                                    >|</span
                                  >

                                  <span class="margin-left10 font666666">
                                    {{ $t("TradeByCountry.CO") }}:</span
                                  >

                                  <span
                                    :class="{
                                      overexperise: NationalIndustryShow,
                                    }"
                                  >
                                    {{ item.street_en }}
                                    <span
                                      style="margin-left: 0px"
                                      v-show="
                                        item.street_en &&
                                        item.street_en != ' ' &&
                                        item.street_en != '' &&
                                        item.cityName != '' &&
                                        item.cityName != ' ' &&
                                        item.cityName
                                      "
                                      >,</span
                                    >
                                    {{ item.cityName }}

                                    <span
                                      style="margin-left: 0px"
                                      v-show="
                                        item.provinceName &&
                                        item.provinceName != ' ' &&
                                        item.provinceName != '' &&
                                        item.cityName != '' &&
                                        item.cityName != ' ' &&
                                        item.cityName
                                      "
                                      >,
                                    </span>
                                    {{ item.provinceName }}
                                    <span
                                      style="margin-left: 0px"
                                      v-show="
                                        !item.provinceName &&
                                        !item.street_en &&
                                        !item.cityName
                                      "
                                    >
                                      -
                                    </span>
                                  </span>
                                  <span class="fontDDDDDD margin-left10"
                                    >|</span
                                  >
                                  <span class="margin-left10">
                                    <!-- {{  item.website   }} -->
                                    {{ item.website ? item.website : "-" }}
                                  </span>
                                </p>
                                <p class="list-text-color">
                                  <span class="font666666">
                                    {{ $t("TradeByCountry.ISIC") }}:</span
                                  ><span
                                    :class="{
                                      overexperise: NationalIndustryShow,
                                    }"
                                  >
                                    <span>
                                      {{ item.isicCode ? item.isicCode : "-" }}
                                    </span>
                                    <span class="fontDDDDDD margin-left10"
                                      >|</span
                                    >
                                    <span class="margin-left10 font666666"
                                      >{{
                                        $t("TradeByCountry.ISICDescription")
                                      }}:</span
                                    >
                                    <span>
                                      <el-popover
                                        :disabled="
                                          // ((item?.isicen?.length)?(item?.isicen?.length):0 ) < 90
                                          true
                                        "
                                        placement="top"
                                        trigger="hover"
                                        popper-class="table_popover"
                                        :content="item.isicen"
                                      >
                                        <span slot="reference">
                                          {{ item.isicen ? item.isicen : "-" }}
                                        </span>
                                      </el-popover>
                                    </span>
                                  </span>
                                </p>
                                <p class="list-text-color">
                                  <span
                                    class="font666666"
                                    v-if="Improtradio == 0"
                                  >
                                    {{ $t("TradeByCountry.Top5Products") }}:
                                  </span>
                                  <span
                                    class="font666666"
                                    v-if="Improtradio == 1"
                                  >
                                    {{
                                      $t("TradeByCountry.Top5ExportProducts")
                                    }}:
                                  </span>
                                  <span
                                    class="font666666"
                                    v-if="Improtradio == 2"
                                    >{{
                                      $t("TradeByCountry.Top5ImportProducts")
                                    }}:
                                  </span>
                                  <span
                                    class="MainProductsMainProductsCommon"
                                    ref="productsContainer"
                                    :class="{
                                      MainProductsMainProducts:
                                        item.MainProductsShow && !item.showMore,
                                    }"
                                  >
                                    <span
                                      class="MainProducts"
                                      v-for="(item, index) in item.products"
                                      :key="index"
                                    >
                                      <el-popover
                                        style="margin-right: 0px"
                                        placement="top"
                                        trigger="hover"
                                        popper-class="table_popover"
                                        :content="item.name"
                                      >
                                        <span
                                          slot="reference"
                                          style="
                                            color: #009ea7;
                                            margin-right: 0px;
                                          "
                                        >
                                          {{ item.name }}
                                        </span>
                                      </el-popover>
                                    </span>
                                  </span>
                                  <span
                                    class="MainProductsAll"
                                    v-if="
                                      item?.products?.length > 0 &&
                                      !item.showMore
                                    "
                                    @click="
                                      item.MainProductsShow =
                                        !item.MainProductsShow
                                    "
                                    >...</span
                                  >
                                </p>
                              </div>
                            </div>
                            <div class="conpany-center-list-right">
                              <p>
                                <el-popover
                                  placement="top"
                                  trigger="hover"
                                  popper-class="table_popover"
                                  :content="
                                    $t('TradeByCountry.ContactInformation')
                                  "
                                >
                                  <span
                                    slot="reference"
                                    class="iconbg flex_center"
                                  >
                                    <i
                                      @click="exportCompanyWeb(item)"
                                      class="iconfont icon-dianhuaheshi"
                                      style="color: #009ea7"
                                    ></i
                                  ></span>
                                </el-popover>

                                <el-popover
                                  placement="top"
                                  trigger="hover"
                                  popper-class="table_popover"
                                  :content="$t('TradeByCountry.SearchTrade')"
                                >
                                  <button
                                    slot="reference"
                                    class="margin20 iconbg flex_center"
                                  >
                                    <i
                                      @click="exportCompanyImport(item)"
                                      class="iconfont icon-lishibaogao"
                                      style="color: #009ea7"
                                    ></i>
                                  </button>
                                </el-popover>
                              </p>
                            </div>
                          </div>
                          <transition name="fade">
                            <div
                              class="flex_box bottom-list-echarts margin-top20 margin-left30"
                              v-show="item.isRotated"
                            >
                              <div class="bottom-list-echarts-li">
                                <div class="flex_center_between_box">
                                  <div
                                    class="bottom-list-echarts-li-left flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <el-tooltip
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          $t('SearchTrade.RegistrationDate')
                                        "
                                        placement="top"
                                      >
                                        <span class="profit-txt">
                                          {{
                                            $t("SearchTrade.RegistrationDate")
                                          }}</span
                                        >
                                      </el-tooltip>

                                      <el-tooltip
                                        :disabled="
                                          item.prifeTeable?.legalStatus
                                            ?.registerDate?.length < 10
                                        "
                                        class="line_1"
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          item.prifeTeable?.legalStatus
                                            ?.registerDate
                                        "
                                        placement="top"
                                      >
                                        <span class="Color009EA7">{{
                                          item.prifeTeable?.legalStatus
                                            ?.registerDate
                                        }}</span>
                                      </el-tooltip>
                                    </div>
                                  </div>
                                  <div
                                    class="bottom-list-echarts-li-right flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{ $t("SearchTrade.Profit") }}</span
                                      >
                                      <el-tooltip
                                        :disabled="
                                          item.prifeTeable?.financialStatus
                                            ?.profit?.length < 10
                                        "
                                        class="line_1"
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          item.prifeTeable?.financialStatus
                                            ?.profit
                                        "
                                        placement="top"
                                      >
                                        <span class="Color009EA7">{{
                                          item.prifeTeable?.financialStatus
                                            ?.profit
                                        }}</span>
                                      </el-tooltip>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex_center_between_box">
                                  <div
                                    class="bottom-list-echarts-li-left flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <el-tooltip
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          $t('SearchTrade.NoofShareholders')
                                        "
                                        placement="top"
                                      >
                                        <span class="profit-txt">
                                          {{
                                            $t("SearchTrade.NoofShareholders")
                                          }}</span
                                        >
                                      </el-tooltip>

                                      <span class="Color009EA7 line_1">{{
                                        item.prifeTeable?.current?.shareholds
                                      }}</span>
                                    </div>
                                  </div>
                                  <div
                                    class="bottom-list-echarts-li-right flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <el-tooltip
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="$t('SearchTrade.TotalAssets')"
                                        placement="top"
                                      >
                                        <span class="profit-txt">
                                          {{
                                            $t("SearchTrade.TotalAssets")
                                          }}</span
                                        >
                                      </el-tooltip>

                                      <el-tooltip
                                        :disabled="
                                          item.prifeTeable?.financialStatus
                                            ?.asset?.length < 10
                                        "
                                        class="line_1"
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          item.prifeTeable?.financialStatus
                                            ?.asset
                                        "
                                        placement="top"
                                      >
                                        <span class="Color009EA7">{{
                                          item.prifeTeable?.financialStatus
                                            ?.asset
                                        }}</span>
                                      </el-tooltip>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex_center_between_box">
                                  <div
                                    class="bottom-list-echarts-li-left flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{
                                          $t("SearchTrade.IndustryCode")
                                        }}</span
                                      >
                                      <span class="Color009EA7 line_1">{{
                                        item.prifeTeable?.current?.industryCode
                                      }}</span>
                                    </div>
                                  </div>
                                  <div
                                    class="bottom-list-echarts-li-right flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{
                                          $t("SearchTrade.CreditRating")
                                        }}</span
                                      >
                                      <span class="Color009EA7 line_1">{{
                                        item.prifeTeable?.creditRatings
                                          ?.creditRating
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex_center_between_box">
                                  <div
                                    class="bottom-list-echarts-li-left flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <el-tooltip
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          $t('SearchTrade.NoofEmployees')
                                        "
                                        placement="top"
                                      >
                                        <span class="profit-txt">
                                          {{
                                            $t("SearchTrade.NoofEmployees")
                                          }}</span
                                        >
                                      </el-tooltip>

                                      <span class="Color009EA7 line_1">{{
                                        item.prifeTeable?.current?.employee
                                          | FilterNum
                                      }}</span>
                                    </div>
                                  </div>
                                  <div
                                    class="bottom-list-echarts-li-right flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{
                                          $t("SearchTrade.CreditScore")
                                        }}</span
                                      >
                                      <span class="Color009EA7 line_1">{{
                                        item.prifeTeable?.creditRatings
                                          ?.creditScore
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex_center_between_box">
                                  <div
                                    class="bottom-list-echarts-li-left flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{ $t("SearchTrade.Listed") }}</span
                                      >
                                      <span class="Color009EA7 line_1">{{
                                        item.prifeTeable?.legalStatus?.listed
                                      }}</span>
                                    </div>
                                  </div>
                                  <div
                                    class="bottom-list-echarts-li-right flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{ $t("SearchTrade.ESGRating") }}</span
                                      >
                                      <span class="Color009EA7 line_1">{{
                                        item.prifeTeable?.creditRatings
                                          ?.ratingESG
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex_center_between_box">
                                  <div
                                    class="bottom-list-echarts-li-left flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{ $t("SearchTrade.Revenue") }}</span
                                      >
                                      <el-tooltip
                                        :disabled="
                                          item.prifeTeable?.financialStatus
                                            ?.profit?.length < 10
                                        "
                                        class="line_1"
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          item.prifeTeable?.financialStatus
                                            ?.profit
                                        "
                                        placement="top"
                                      >
                                        <span class="Color009EA7">{{
                                          item.prifeTeable?.financialStatus
                                            ?.profit
                                        }}</span>
                                      </el-tooltip>
                                    </div>
                                  </div>
                                  <div
                                    class="bottom-list-echarts-li-right flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{ $t("SearchTrade.DQI") }}</span
                                      >
                                      <span class="Color009EA7 line_1">{{
                                        item.prifeTeable?.creditRatings?.dqi
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  @click="setNews(item, 'prife')"
                                  class="MoreCompany margin-top20"
                                >
                                  {{ $t("SearchTrade.MoreCoDetails") }}
                                </div>
                              </div>
                              <div class="bottom-list-echarts-li">
                                <div
                                  ref="ImportEchart"
                                  style="width: 100%; height: 210px"
                                ></div>
                              </div>
                              <div class="bottom-list-echarts-li">
                                <p class="bottom-list-echarts-head">
                                  {{ $t("SearchTrade.CoNews") }}
                                </p>
                                <ul class="margin-bottom10">
                                  <li
                                    class="flex_center_between_box"
                                    v-for="(ite, index) in item.NewstableData"
                                    :key="index"
                                  >
                                    <el-tooltip
                                      class="item"
                                      effect="light"
                                      :visible-arrow="false"
                                      :content="ite.titleEn"
                                      placement="top"
                                      :disabled="ite.titleEn?.length < 35"
                                    >
                                      <div
                                        @click="setid(ite)"
                                        class="news-text"
                                      >
                                        {{ ite.titleEn }}
                                      </div>
                                    </el-tooltip>

                                    {{ ite.date }}
                                  </li>
                                </ul>
                                <div
                                  @click="setNews(item, 'news')"
                                  v-if="item.NewstableData?.length > 6"
                                  class="MoreCompany margin-top10"
                                >
                                  {{ $t("SearchTrade.MoreCoNews") }}
                                </div>
                              </div>
                            </div>
                          </transition>
                          <div :class="{'margin-top20' : item.isRotated}" :style="{height: item.isRotated ? '10px' : '0px'}"></div>
                          <i class="iconfont icon-jiantouxia icon_sanjiaoLocation"
                            :class="{ rotate: item.isRotated }"
                            @click="!NationalIndustryShow && getCompanyDetailList(item, index)"
                          ></i>
                        </li>
                      </transition-group>
                    </draggable>
                  </ul>
                  <div
                    class="ShowAll flex_center font18 margin-top20"
                    v-if="page.pageSize < page.total"
                    @click="ShowAll"
                  >
                    {{ $t("SearchTrade.ShowAll") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Login :loginAndCreatePop.sync="loginDialog"></Login>
    <ContactInformation
      :ContactObj="ContactInfo"
      :suoClose="ContactIn"
      @closeCloseDialog="clossuoDialog($event)"
    >
    </ContactInformation>
  </div>
  <!--srcviewscompanylistriskvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import draggable from "vuedraggable";
import { findPartnerDetail } from "@/api/searchApi.js";
import ContactInformation from "../../TradeProduct/ContactInformation.vue";
import { formatNum } from "@/views/company/details/Background/utils";

import Login from "@/components/login.vue";

import {
  getCompanyIndustryInfo,
  getCompanyDetail,
  getPdfLink,
  leadsPostFilter,
  getsearchExport,
  getHuokePartPrivilege,
  searchMoreEmail,
  getSuppliersAndBuyersList,
  getSuppliersAndBuyersFilter,
} from "@/api/companyApi.js";
import { mixins1 } from "@/mixins/index";
export default {
  name: "",
  props: {},
  watch: {},
  mixins: [mixins1],
  components: {
    draggable,
    Login,
    ContactInformation,
  },

  data() {
    return {
      PCMoudele: [],
      ContactInfo: {
        aaa_id: "",
        web_site: "",
        company_country: "",
        file_name:"",
      },
      LastUpdate: "",
      ContactIn: false,
      loginDialog: false,
      Compare: false,
      supplierNamevalue: "",
      supplierNameList: [],
      Improtradio: 0,
      buyerNameList: [],
      buyerNamevalue: "",
      isShowTooltip: false,
      RiskLoding: false,
      MainProductsShow: "",

      compareList: [],
      totle: 0,
      checked: "",
      pageNo: 1,
      disabled: false,
      NationalIndustryActive: "null",
      isRotated: false,

      NationalIndustryShow: false,

      isOpenSlct: false,

      checkList: [],
      aaaid: "",

      CompanyList: [],
      parentTable: [],
      token: localStorage.getItem("token"),
      Saved: undefined,
      isChecked: "",
      DetailsFormImportlist: [],
      riskTotal: "",
      QuestionPageList: [],

      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      chageItIndex: 0,
      chageItTrue: false,
      ProductNameList: [],
      ProductName: "",

      openListIndex: null,
    };
  },
  methods: {
    CloseListExpandInfo(index = null) {
      if (this.openListIndex !== null) {
        const prevItem = this.CompanyList[this.openListIndex];
        if (prevItem) prevItem.isRotated = false;
      }

      this.openListIndex =
        index !== null && this.openListIndex !== index ? index : null;
    },
    
    // 获取公司详情数据
    getCompanyDetailList(item, index) {
      this.chageItTrue = true;
      let that = this;
      if (this.PCMoudele[11].hasPrivilege) {
        //为什么！！！！
        item.isFavorite = !item.isFavorite;
        item.isFavorite = !item.isFavorite;
        //为什么！！！！

        //         console.log(item);
        //         console.log("aaaId:"+item.aaa_id);
        // console.log("countryCode:"+item.company_country);
        // console.log("industryCode:"+item.isic_code);

        const isCurrentlyOpen = this.openListIndex === index;
        this.CloseListExpandInfo(index);
        if (!isCurrentlyOpen) {
          item.isRotated = true;
          getCompanyDetail({
            aaaId: item.aaaid,
            countryCode: item.countryCode,
            industryCode: item.isicCode,
          })
            .then((res) => {
              // 更新数据
              item.NewstableData = res.data.news;
              item.prifeTeable = res.data.snapshotVO;
              item.InsdustryTable = res.data.incomePanel.industryIncomes;
              item.companyIncomes = res.data.incomePanel.companyIncomes;

              // 图表配置
              const option = {
                tooltip: {
                  trigger: "axis",
                  axisPointer: {
                    type: "cross",
                  },
                  formatter: function(params) {
                    let result = params[0].name + '<br/>';
                    params.forEach(function(item) {
                      let formattedValue =  formatNum(item.value);
                      result += item.marker + item.seriesName + ': ' + formattedValue + '<br/>';
                    });
                    return result;
                  },
                },
                grid: {
                  left: "0%",
                  right: "0%",
                  top: "12%",
                  bottom: "0%",
                  containLabel: true,
                },
                legend: {
                  right: "10px",
                  top: "0px",
                },
                xAxis: [
                  {
                    type: "category",
                    data: item.companyIncomes.map((item) => item.year),
                    axisTick: {
                      show: false,
                    },
                  },
                  {
                    type: "category",
                    data: item.InsdustryTable.map((item) => item.year),
                    axisTick: {
                      show: false,
                    },
                    axisLabel: {
                      show: false,
                    },
                  },
                ],
                yAxis: [
                  {
                    type: "value",
                    axisLabel: {
                      formatter: function (value) {
                        return formatNum(value); // 格式化为千分位
                      },
                      show: false,
                    },
                    axisPointer: {
                      label: {
                        formatter: function (params) {
                          return  formatNum(params.value);
                        }
                      }
                    },
                  },
                  {
                    type: "value",
                    axisLabel: {
                      formatter: function (value) {
                        return  formatNum(value); // 格式化为千分位
                      },
                      show: false,
                    },
                    axisPointer: {
                      label: {
                        formatter: function (params) {
                          return  formatNum(params.value);
                        }
                      }
                    },
                  },
                ],
                series: [
                  {
                    name: this.$t("SearchTrade.IndustryMean"),
                    type: "bar",
                    barWidth: "15",
                    itemStyle: { color: "#009ea7" },
                    emphasis: {
                      itemStyle: {
                        color: "#009ea7",
                      },
                    },
                    data: item.InsdustryTable.map((item) => item.income),
                  },
                  {
                    name: this.$t("SearchTrade.TargetSubjectRevenue"),
                    type: "line",
                    barWidth: "20",
                    yAxisIndex: 1,
                    itemStyle: { color: "#FF7600" },
                    emphasis: {
                      itemStyle: {
                        color: "#FF7600",
                      },
                    },
                    data: item.companyIncomes.map((item) => item.income),
                  },
                ],
              };

              // 获取图表 DOM
              const chartDom = this.$refs.ImportEchart[index];
              let chart = this.$echarts.getInstanceByDom(chartDom);

              // 如果没有找到图表实例，则初始化一个新的图表
              if (!chart) {
                chart = this.$echarts.init(chartDom);
                item.chartInstance = chart; // 存储图表实例
              } else {
                // 如果找到了图表实例，先销毁它
                chart.dispose();
                // 重新初始化图表
                chart = this.$echarts.init(chartDom);
                item.chartInstance = chart; // 更新存储的图表实例
              }

              // 设置图表选项
              this.$nextTick(() => {
                if (chart) {
                  chart.setOption(option); // 仅在 chart 存在时设置选项
                }
              });

              // 更新数据
              this.$set(item, "item.NewstableData", res.data.news);
              // this.CompanyList[index].chartInstance = chart; // 更新 CompanyList 中的图表实例
            })
            .catch((error) => {
              console.error("error:", error);
            });
        }
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },
    //新闻跳转
    setid(row) {
      if (row.link == undefined) {
        getPdfLink({ articleRef: row.id }).then((res1) => {
          // let res1 = JSON.parse(crypto.decrypt(res));

          if (res1.data?.includes("http")) {
            let routeData = res1.data;
            window.open(routeData, "_blank");
          } else {
            let routeData = "http://" + res1.data;
            window.open(routeData, "_blank");
          }
          // let routeData = res1.data;
          // window.open(routeData, '_blank');
        });
      }
      if (row.link?.includes("http")) {
        let routeData = row.link;

        window.open(routeData, "_blank");
      } else {
        let routeData = "http://" + row.link;
        window.open(routeData, "_blank");
      }
      // let routeData = row.url;
      // window.open(routeData, '_blank');
    },

    ShowAll() {
      this.page.pageSize = this.page.pageSize + 10;
      this.getSearchList();
    },
    clearAllTags() {
      this.Improtradio = 0;
      this.ProductName = "";
      this.buyerNamevalue = "";
      this.ChangeRadio();
    },

    ChangeRadio() {
      this.NationalIndustryShow = false;
      this.NationalIndustryActive = "null";

      this.page.pageSize = 10;
      this.getSuppliersAndBuyersFilterList();
      this.getSearchList();
    },
    getSuppliersAndBuyersFilterList() {
      getSuppliersAndBuyersFilter({
        countryCode: this.$route.query.id3a,
        tradeDim: 3,
        aaaid: this.buyerNamevalue,
        tradeCode: this.ProductName,
        tradeType: this.Improtradio,
      }).then((res) => {
        if (res.code == 200) {
          this.buyerNameList = res.data.companyNames;
          this.ProductNameList = res.data.productNames;
        }
      });
    },
    // 获取列表数据
    getSearchList(leadsPostFilter) {
      this.RiskLoding = true;
      getSuppliersAndBuyersList({
        aaaid: this.buyerNamevalue,
        tradeType: this.Improtradio,
        page: 1,
        pageSize: this.page.pageSize,
        countryCode: this.$route.query.id3a,
        tradeYear: "",
        tradeDim: "3",
        tradeCode: this.ProductName,
      }).then((res) => {
        if (res.code == 200) {
          this.RiskLoding = false;
          this.page.total = res.data.total;
          let parentTable = res.data.rows;
          parentTable.map((item, index) => {
            let countryImg = this.getCountryImgUrl(item.countryCode);
            item.MainProductsShow = false;
            if (countryImg) {
              let flag = require("../../../../../static" + countryImg);
              parentTable[index].flag = flag;

              this.refresh++;
            }
          });
          this.CompanyList = parentTable;
          // isRotated
          this.CompanyList.forEach((item) => {
            item.isRotated = false;
          });

          // 数据加载完成后检查高度
          this.$nextTick(() => {
            this.CompanyList.forEach((item, index) => {
              const container = this.$refs.productsContainer?.[index];
              this.$refs.productsContainer?.[index].classList.remove(
                "MainProductsMainProductsCommonH",
              );
              if (container.offsetHeight > 38) {
                this.$refs.productsContainer?.[index].classList.add(
                  "MainProductsMainProducts",
                );
                item.MainProductsShow = true;
                item.showMore = false;
              } else {
                this.$refs.productsContainer?.[index].classList.add(
                  "MainProductsMainProductsCommonH",
                );
                item.showMore = true;
              }
            });
          });
        } else {
          this.RiskLoding = false;
        }
      });
    },
    clossuoDialog(value) {
      this.ContactIn = value;
    },

    // 点击列表出现右侧数据
    NationalIndustry(item, index) {
      this.chageItTrue = true;
      this.NationalIndustryShow = true;
      // if(this.PCMoudele[16].hasPrivilege){

      // this.LastUpdate=item.update_year
      //     getCompanyIndustryInfo({
      //     aaaId: item.aaa_id,
      //     countryCode: item.company_country,
      // }).then((Res) => {
      //     if (Res.code == 200) {
      //         this.CompanyObj = Res.data;

      //         this.resizeFn()
      //     }else{
      //         this.CompanyObj = null
      //         this.resizeFn()
      //     }
      // });

      // this.NationalIndustryActive = index;

      // if(this.NationalIndustryActive !=undefined){

      // }else{
      //     this.NationalIndustryShow = false
      // }
      // }else{
      //     this.$bus.$emit('show-permission-dialog', '您没有权限访问该功能！')
      // }
    },
    rifghtUpdate() {
      this.NationalIndustryShow = false;
      this.NationalIndustryActive = "null";
    },
    // echarts监听 浏览器宽度改变 echarts改变

    // 获取权限
    getHuokePartPrivilegeList() {
      getHuokePartPrivilege({
        moduleType: 7,
      }).then((res) => {
        if (res.code == 200) {
          this.PCMoudele = res.data;
        }
      });
    },

    // web导出
    exportCompanyWeb(item) {
      this.ContactIn = true;
      this.ContactInfo.aaa_id = item.aaaid;

      this.ContactInfo.web_site = item.website;

      this.ContactInfo.company_country = item.countryCode;
        // this.ContactInfo.file_name = item.companyName;
    },
    DetailsFormConcat() {
      this.chageItTrue = true;
      if (this.PCMoudele[15].hasPrivilege) {
        let params = {
          page: 1,
          pageSize: 100,
          id3a: this.aaaId,
          website: this.itemList.web_site,
          countryCode: this.itemList.company_country,
        };
        //    return   this.DetailsFormImportlist
        return searchMoreEmail(params).then((res) => {
          if (res.code == 200) {
            if (res.data.contacts.length == 0) {
              this.$message({
                message: this.$t("SearchTrade.NoData"),
                type: "success",
              });
            } else {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            return res.data.contacts;
          } else {
            return [];
          }
        });
      }
    },
    DetailsFormImport() {
      this.chageItTrue = true;
      if (this.PCMoudele[15].hasPrivilege) {
        return getsearchExport({
          page: 1,
          pageSize: 100,
          export_aaaid: this.aaaId,
          import_aaaid: this.aaaId,
        }).then((res) => {
          if (res.code == 200) {
            if (res.data.rows.length == 0) {
              this.$message({
                message: this.$t("SearchTrade.NoData"),
                type: "success",
              });
            } else {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            return res.data.rows;
          } else {
            return [];
          }
        });
      }
    },
    // 贸易链路导出
    exportCompanyImport(item) {
      let SACode1 = "";
      let newscountry = JSON.parse(localStorage.getItem("countryList"))[0]
        .countryList;

      newscountry.map((ite) => {
        if (ite.countryCode == item.countryCode) {
          SACode1 = ite.dowjonesCountrycode;
        }
      });
      let routeData = this.$router.resolve({
        // Tradecompany/Trade/
        // /company/details
        path:
          "/index/tradeCompany/Trade/" +
          item.aaaid +
          // "/background/snapshot?id3a=" +
          "/tradeMap/map?id3a=" +
          item.aaaid +
          "&companyCountry=" +
          item.countryCode +
          "&SACode1=" +
          SACode1 +
          "&companyName=" +
          item.countryName +
          "&Tradechannel=Company" +
          "&Moudles=Trade",
      });
      window.open(routeData.href, "_blank");
    },

    setToolsfalse() {
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: false,
      });
    },
    // 工具栏高亮控制
    setToolsAcive() {
      this.$store.dispatch("app/setTools", {
        name: "Optimize",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "filter",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "menu",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false && this.token,
      });
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: true && this.token,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: false,
      });

      //   this.$store.dispatch("app/setTools", "filter",'isActive',false);
    },
    // 收藏

    // 删除元素
    DelClick(item, index) {
      if (this.PCMoudele[13].hasPrivilege) {
        this.deledeLaeadsDialog = true;
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },

    // 移动
    onMove(e) {
      if (e.relatedContext.element.isDing == true) return false;
      return true;
    },

    // 全选操作
    changeItemChecked(value) {
      if (this.CompanyList.filter((item) => item.isChecked).length > 0) {
        this.checked = true;
      } else {
        this.checked = false;
      }

      let selectCompany = this.CompanyList.filter((item) => item.isChecked);
      this.$store.dispatch("app/setchangeList", selectCompany);
      this.compareList = selectCompany;
      // this.$nextTick(() => { });

      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: selectCompany.length > 0 && this.SavyeLeadsSuo == false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: true && this.Compare == false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: this.compareList.length > 0 && this.compareList.length < 4,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: selectCompany.length > 0,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: selectCompany.length > 0,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: selectCompany.length > 0,
      });
    },
    // 全选操作
    changeSlctAll(value) {
      this.CompanyList.slice(0, 20).forEach((item) => {
        item.isChecked = value;
      });
      let selectCompany = this.CompanyList.slice(0, 20).filter(
        (item) => item.isChecked,
      );
      this.compareList = selectCompany;
      this.$store.dispatch("app/setchangeList", selectCompany);
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "highlight-cell"; // 设置你想要的背景色
      }
    },

    // setTools
    setTools() {
      this.$store.dispatch("app/setTools", {
        name: "menu",
        key: "isActive",
        value: true,
      });

      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: true,
      });

      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
    }, // getDetail
  },
  computed: {},
  created() {
    this.setToolsfalse();
  },
  mounted() {
    //
    this.$emit("UpdatamarkTotalList", true);

    this.$store.dispatch("app/setTools", {
      name: "menu",
      key: "isActive",
      value: true,
    });
    this.getSuppliersAndBuyersFilterList();
    this.getSearchList();
    this.setToolsfalse();
    if (this.token) {
      this.getHuokePartPrivilegeList();
    }
  },
  beforeDestroy() {},
};
</script>
<style scoped>
.operations-headspan {
  color: #009ea7;
}
.ud6279 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-top: 7.642857142857143rem;
}

.u96d4d {
  width: 29rem;
}

.uba4wV3 {
  margin-right: 1.0714285714285714rem;
  margin-bottom: 0.7142857142857143rem;
  margin-top: 0.7142857142857143rem;
  margin-left: 1.0714285714285714rem;
}

.ub7918 {
  color: #999999;
  margin-bottom: 0.7142857142857143rem;
  font-size: 1.1428571428571428rem;
  text-align: left;
  font-style: normal;

  margin-bottom: 0.7142857142857143rem;
  overflow: hidden;
}

.uVwoZks {
  width: 100%;
}

.hidemenu {
  display: block;
  width: 0em;
  padding-left: 0em;
  padding-top: 0em;
  padding-bottom: 0em;
  padding-right: 0em;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
}

.udb507 {
  width: calc(100% - 300px);
  display: flex;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  flex-direction: column;
  margin-left: 10px;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}

.scrollbar {
  overflow: hidden;
}

.udb507two {
  width: 100%;
}

.risk-right {
  width: 540px;
  padding: 20px;
  background: #ddedee;
  height: 45rem;
  border-radius: 0 10px 10px 10px;
}

.risk-center-list {
  flex: 1;
  width: 49%;
  overflow-y: scroll;
}

.Upadetime {
  font-size: 1.2857142857142858rem;
  color: #666666;
  margin-right: 2.142857142857143rem;
}

.flex_center_between_box p {
  font-size: 24px;
  color: #1a2332;
  min-height: 22px;
  margin-bottom: 16px;
  display: flex;
}

.risk-right-content {
  padding: 1.4285714285714286rem 0rem;
  border-top: 0.07142857142857142rem solid #cccccc;
}

.risk-right-content-title {
  font-size: 1.4285714285714286rem;
  color: #1a2332;
  height: 1.7142857142857142rem;
  margin-bottom: 1.4285714285714286rem;
  font-family: "Arial Bold";
}

.right-txt {
  text-align: right;
  font-size: 1.2857142857142858rem;
  color: #1a2332;
  line-height: 1.8571428571428572rem;
}

.left-txt {
  font-size: 1.2857142857142858rem;
  color: #666666;
}

.margin16 {
  margin-top: 1.1428571428571428rem;
}

.highlight-cell {
  background-color: #f2f5f9 !important;
}

.risk-right .el-table .cell {
  color: #1a2332;
}

.table-content {
  height: 3.5714285714285716rem !important;
  line-height: 3.5714285714285716rem;
}

.risk-right .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}

.conpany-center-list {
  padding: 30px 40px 16px 20px;
  background: #f5f5f5;
  border-radius: 10px;
  margin-bottom: 10px;
}

.conpany-center-list-left {
  font-size: 24px;
  color: #1a2332;
  display: flex;
  align-items: flex-start;
  width: 90%;
  max-width: 90%;
}

.conpany-center-list-right {
  width: 10%;
}

.risk-center-list .el-checkbox__inner,
.Alchecked .el-checkbox__inner {
  height: 1.4285714285714286rem !important;
  width: 1.4285714285714286rem !important;
}

.conpany-center-list-left .el-checkbox__inner {
  margin-top: 0.2857142857142857rem !important;
}

.risk-center-list .el-checkbox__inner::after,
.Alchecked .el-checkbox__inner::after {
  height: 0.7142857142857143rem;
  left: 0.5rem;
}

.risk-center-list .el-checkbox__input.is-checked .el-checkbox__inner,
.Alchecked .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #8e86dd;
  border-color: #8e86dd;
}

.risk-center-list .el-checkbox__input.is-focus .el-checkbox__inner,
.Alchecked .el-checkbox__input.is-focus .el-checkbox__inner,
.Alchecked
  .el-checkbox__inner:hover
  .risk-center-list
  .el-checkbox__inner:hover {
  border: 0.07142857142857142rem solid #dcdfe6;
}

.risk-center-list .el-checkbox__input.is-checked + .el-checkbox__label,
.Alchecked .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #1a2332;
}

.indexPositon {
  margin-right: 1.4285714285714286rem;
  color: #009ea7;
  width: 1.4285714285714286rem;
}

.indexPositonactive {
  margin-right: 10px;
  color: #999999;
  width: 30px;
  font-family: "Arial Bold";
  min-width: 30px;
}

.list-text-color {
  font-size: 18px !important;
  color: #666666 !important;
  display: flex;
  align-items: center;
}

.list-text-color span {
  color: #1a2332;
  margin-right: 10px;
}

.overexperise {
  max-width: 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: fit-content;
}

.list-text-color img,
.contry_img {
  width: 46px;
  height: 32px;
  padding: 5px;
}
.margin20 {
  margin-left: 20px;
}

.iconbg {
  width: 3.5714285714285716rem;
  height: 3.5714285714285716rem;
  background: #ddedee;
  border-radius: 50%;
  cursor: pointer;
}

.conpany-center-list-right p {
  justify-content: flex-end;
  margin-bottom: 0px;
}

.left_menu_title {
  font-size: 1.7142857142857142rem;
  color: #1a2332;
  margin: 1.4285714285714286rem 0rem;
  padding-bottom: 10px;
  border-bottom: 1px solid #dddddd;
  font-family: "Arial Bold";
}

.left_menu_question p {
  font-size: 18px;
  color: #1a2332;
  margin-bottom: 10px;
  font-family: "Arial Bold";
}

.left_menu_question .el-input__inner {
  height: 2.5714285714285716rem;
  background: #ffffff;
  border-radius: 10px;
  font-size: 1.1428571428571428rem;
  color: #1a2332;
  padding-left: 0.7142857142857143rem !important;
}

.left_menu_question /deep/ .el-select .el-input.is-focus .el-input__inner,
.left_menu_question /deep/ .el-select .el-input__inner:focus {
  border: 0.07142857142857142rem solid #cccccc !important;

  line-height: 2.428571rem !important;
}

.left_menu_question {
  margin-bottom: 0.7142857142857143rem;
  padding-bottom: 1.4285714285714286rem;
}

.FilterQuestion .left_menu_question {
  padding-bottom: 0rem;
}

/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #f5f5f5;
  border-color: #cccccc;
  color: #999999;
  line-height: 2.428571rem !important;
}

.left_menu_bottom {
  font-size: 1.1428571428571428rem;
  color: #1a2332;
  margin-bottom: 3rem;
}

.profit-txt {
  width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Color009EA7 {
  text-align: right;
}

.question-detail_cont-list h3 {
  margin-top: 0.7142857142857143rem;
  font-family: "Arial";
  font-weight: 400;
  font-size: 1.2857142857142858rem;
  color: #1a2332;
}

button:disabled {
  cursor: no-drop !important;
}

.el-popover {
  padding: 10px !important;
  min-width: auto;
}

.uedbd2 {
  height: 100%;
}

.right_cont_box {
  height: 100%;
  overflow-y: auto;
}

.IElabel {
  font-size: 16px;
  color: #ff7600;
  text-align: center;
  background: #fff8f1;
  line-height: 26px;
  width: 70px;
  border-radius: 10px;
  border: 1px solid #ff7600;
  margin-top: 2px;
  margin-bottom: 2px;
}

.IElabelExport {
  background: #f4fbff;
  border-radius: 10px;
  border: 1px solid #1290c9;
  color: #1290c9;
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
}

.left_menu_context-title {
  font-size: 18px;
  color: #1a2332;
  font-family: "Arial Bold";
  margin-bottom: 20px;
  position: relative;
}

.left_menu_context {
  margin-bottom: 30px;
}

.left_menu_context /deep/ .el-input__inner {
  height: 36px !important;
}

/deep/ .el-radio {
  justify-content: flex-start;
  font-size: 1.1428575rem;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #009ea7;
  font-size: 16px;
}

/deep/ .el-radio__label {
  font-size: 16px;
  color: #1a2332;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #009ea7;
  background: #fff;
}

/deep/ .el-radio__input.is-checked .el-radio__inner::after {
  background: #009ea7;
}

.Clear_all {
  position: absolute;
  right: 0px;
  font-size: 16px;
  z-index: 999;
  cursor: pointer;
}

.MainProducts {
  background: #f5f5f5;
  border-radius: 10px;
  border: 1px solid #009ea7;
  padding: 5px;
  margin-top: 2px;
  margin-bottom: 3px;
  height: 28px;
  line-height: 18px;
  margin-right: 10px;
  font-size: 16px;
  color: #009ea7;
  display: inline-block;
  max-width: 28%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.MainProductsAll {
  width: 30px;
  height: 30px;
  background: #ddedee;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  color: #009ea7;
  cursor: pointer;
}
.MainProductsMainProductsCommon {
  width: calc(100% - 235px);
  margin-right: 10px;
}
.MainProductsMainProductsCommonH {
  height: 35px;
}
.MainProductsMainProducts {
  height: 35px;
  white-space: nowrap;
  overflow: hidden;
}

/deep/ .el-scrollbar__wrap {
  max-width: 21rem !important;
}
.margin-left10 {
  margin-left: 10px !important;
  cursor: pointer;
}

.margin-top4 {
  margin-top: 4px !important;
  cursor: pointer;
}
.icon-dianhuaheshi {
  font-size: 26px;
}
.icon-lishibaogao {
  font-size: 22px;
}
.productContent {
  width: calc(100% - 40px);
}
.productTitle {
  min-height: 34px;
  width: calc(100% - 150px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.profit-txt {
  width: 125px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.icontransform {
  display: inline-block;
  transition: transform 0.5s ease;
  cursor: pointer;
  transform: rotate(0deg);
  color: #009ea7;
  font-size: 16px;
}

.bottom-list-echarts {
  /* padding-left: 2.8142857142857144rem; */
  display: flex;
  justify-content: space-between;
}

.bottom-list-echarts-li {
  padding: 1.4285714285714286rem;
  background: #fff;
  height: 18.571428571428573rem;
  /* flex: 1; */
  width: 33%;
  padding-bottom: 0.7142857142857143rem;
}

.icontransform {
  display: inline-block;
  transition: transform 0.5s ease;
  /* 设置过渡效果 */
  cursor: pointer;
}

.rotate {
  transform: rotate(-180deg);
  /* 旋转180度 */
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active 在 Vue 2.x 中 */ {
  opacity: 0;
  /* 初始透明度 */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
  /* 淡入淡出动画 */
}
.iconbgActive {
  background-color: #009ea7;
}

.bottom-list-echarts-li-left {
  border-right: 1px solid #dddddd;
  padding-right: 20px;
  width: 50%;
}

.bottom-list-echarts-li-right {
  padding-left: 20px;
  width: 50%;
}

.bottom-list-echarts-li-left-text {
  font-size: 14px;
  line-height: 30px;
  color: #1a2332;
  width: 100%;
  gap: 15px;
}

.bottom-list-echarts-head {
  font-size: 18px !important;
  color: #1a2332;
  font-family: "Arial bold";
}

.bottom-list-echarts-box {
  padding-top: 5px;
  margin-top: 5px;
  border-top: 1px solid #dddddd;
}

.news-text {
  font-size: 14px;
  color: #009ea7;
  margin-bottom: 10px;
  width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.bottom-list-echarts-li ul {
  padding-top: 10px;
  border-top: 1px solid #dddddd;
  max-height: 73%;
  overflow: hidden;
}

.MoreCompany {
  font-size: 14px;
  color: #009ea7;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  text-decoration-line: underline;
}

.icon_sanjiaoLocation{
  position: absolute;
  bottom: 20px;
  right: 40px;
  color: #000000;
  cursor: pointer;
}

.tptitleSplit {
  color: #cccccc;
  font-size: 20px;
  line-height: 20px;
  margin: 20px 30px;
}

.total_companies{
  color: #1a2332;
}

@media (max-width: 1920px) {
  .left_menu_question p {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .left_menu_question {
    margin-bottom: 7px;
    padding-bottom: 15px;
  }
  .left_menu_context {
    margin-bottom: 20px;
  }
  .Clear_all {
    font-size: 14px;
  }
  .trade_date_picker,
  .left_menu_context /deep/ .el-input__inner {
    height: 32px !important;
    font-size: 14px;
  }
  .trade_date_picker {
    width: 225px;
  }
  .trade_bottom_right_top {
    margin-bottom: 7px;
    font-size: 14px;
  }
  .conpany-center-list {
    padding: 22px 30px 12px 15px;
    margin-bottom: 7px;
  }
  .flex_center_between_box p {
    font-size: 18px;
    min-height: 16px;
    margin-bottom: 12px;
  }
  .indexPositonactive {
    margin-right: 7px;
    width: 22px;
    min-width: 22px;
  }
  .conpany-center-list-left {
    font-size: 18px;
  }
  .icon-dianhuaheshi {
    font-size: 20px;
  }
  .icon-lishibaogao {
    font-size: 16px;
  }
  .icon-shoucang {
    font-size: 20px;
  }
  .icon-arrowup-copy,
  .icon-arrowup {
    font-size: 16px;
    margin-right: 7px;
  }
  .list-text-color img {
    width: 35px;
    height: 24px;
    margin-right: 4px;
  }
  .list-text-color {
    font-size: 16px !important;
  }
  .list-text-color span {
    margin-right: 8px;
  }
  .iconbg {
    width: 37px;
    height: 37px;
  }
  .risk-right {
    width: 480px;
    padding: 15px;
    height: 43rem;
  }

  /deep/ .el-radio__input.is-checked + .el-radio__label {
    color: #009ea7;
    font-size: 14px;
  }

  /deep/ .el-radio__label {
    font-size: 14px;
    color: #1a2332;
  }

  .margin-left10 {
    margin-left: 8px !important;
    cursor: pointer;
  }
  .margin-top4 {
    margin-top: 3px !important;
    cursor: pointer;
  }
  .productContent {
    width: calc(100% - 29px);
  }
  .productTitle {
    min-height: 26px;
  }
  .margin20 {
    margin-left: 15px;
  }
  .IElabel {
    font-size: 12px;
    color: #ff7600;
    text-align: center;
    background: #fff8f1;
    line-height: 20px;
    width: 53px;
    border-radius: 10px;
    border: 1px solid #ff7600;
    margin-top: 2px;
    margin-bottom: 2px;
  }

  .IElabelExport {
    background: #f4fbff;
    border-radius: 10px;
    border: 1px solid #1290c9;
    color: #1290c9;
    margin-top: 2px;
    margin-bottom: 2px;
    margin-left: 8px;
  }
  .MainProducts {
    font-size: 12px;
    margin-right: 8px;
  }
  .MainProductsMainProductsCommon {
    width: calc(100% - 211px);
    margin-right: 8px;
  }
  .MainProductsMainProductsCommonH {
    height: 32px;
  }
  .MainProductsMainProducts {
    height: 32px;
  }
  .udb507 {
    width: calc(100% - 255px);
  }
  .left_menu_context-title {
    font-size: 16px;
    margin-bottom: 7px;
  }

  .icontransform {
    font-size: 12px;
  }

  .bottom-list-echarts {
    gap: 15px;
  }

  .bottom-list-echarts-li {
    padding: 15px 15px 7px;
    height: 240px;
  }

  .bottom-list-echarts-li-left {
    padding-right: 15px;
  }

  .bottom-list-echarts-li-right {
    padding-left: 15px;
  }

  .bottom-list-echarts-li-left-text {
    font-size: 14px;
    line-height: 30px;
    gap: 12px;
  }

  .Color009EA7 {
    font-size: 14px;
  }

  .bottom-list-echarts-head {
    font-size: 16px !important;
  }

  .news-text {
    font-size: 14px;
    margin-bottom: 7px;
  }

  .bottom-list-echarts-li ul {
    padding-top: 7px;
  }

  .MoreCompany {
    line-height: 20px;
  }

  .icon_sanjiaoLocation{
    bottom: 15px;
    right: 30px;
  }
  
  .tptitleSplit {
    font-size: 20px;
    line-height: 20px;
    margin: 10px 23px;
  }
}
@media screen and (max-width: 1439px) {
  .left_menu_question p {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .left_menu_question {
    margin-bottom: 6px;
    padding-bottom: 13px;
  }
  .left_menu_context {
    margin-bottom: 20px;
  }
  .Clear_all {
    font-size: 12px;
  }
  .trade_bottom_right_top {
    margin-bottom: 6px;
    font-size: 12px;
  }
  .conpany-center-list {
    padding: 20px 27px 10px 13px;
    margin-bottom: 6px;
  }
  .flex_center_between_box p {
    font-size: 16px;
    min-height: 15px;
    margin-bottom: 10px;
  }
  .indexPositonactive {
    margin-right: 6px;
    width: 20px;
    min-width: 20px;
  }
  .conpany-center-list-left {
    font-size: 16px;
  }
  .icon-dianhuaheshi {
    font-size: 18px;
  }
  .icon-lishibaogao {
    font-size: 15px;
  }
  .icon-shoucang {
    font-size: 18px;
  }
  .icon-arrowup-copy,
  .icon-arrowup {
    font-size: 16px;
    margin-right: 6px;
  }
  .list-text-color img {
    width: 31px;
    height: 21px;
    margin-right: 3px;
  }
  .list-text-color {
    font-size: 14px !important;
  }
  .list-text-color span {
    margin-right: 7px;
  }
  .iconbg {
    width: 33px;
    height: 33px;
  }
  .risk-right {
    width: 500px;
    padding: 13px;
    min-height: 42rem;
  }
  /deep/ .el-radio__input.is-checked + .el-radio__label {
    color: #009ea7;
    font-size: 12px;
  }

  /deep/ .el-radio__label {
    font-size: 12px;
    color: #1a2332;
  }
  .margin-left10 {
    margin-left: 7px !important;
    cursor: pointer;
  }
  .margin-top4 {
    margin-top: 3px !important;
    cursor: pointer;
  }
  .productContent {
    width: calc(100% - 26px);
  }
  .productTitle {
    min-height: 23px;
  }
  .margin20 {
    margin-left: 13px;
  }

  .IElabel {
    font-size: 10px;
    color: #ff7600;
    text-align: center;
    background: #fff8f1;
    line-height: 17px;
    width: 46px;
    border-radius: 10px;
    border: 1px solid #ff7600;
    margin-top: 2px;
    margin-bottom: 2px;
  }

  .IElabelExport {
    background: #f4fbff;
    border-radius: 10px;
    border: 1px solid #1290c9;
    color: #1290c9;
    margin-top: 2px;
    margin-bottom: 2px;
    margin-left: 7px;
  }
  .MainProducts {
    font-size: 11px;
    margin-right: 7px;
  }
  .MainProductsMainProductsCommon {
    width: calc(100% - 189px);
    margin-right: 7px;
  }
  .MainProductsMainProducts {
    height: 30px;
  }
  .udb507 {
    width: calc(100% - 225px);
  }
  .left_menu_context-title {
    font-size: 14px;
    margin-bottom: 6px;
  }

  .bottom-list-echarts {
    gap: 12px;
  }

  .bottom-list-echarts-li {
    padding: 12px 12px 6px;
  }

  .bottom-list-echarts-li-left {
    padding-right: 12px;
  }

  .bottom-list-echarts-li-right {
    padding-left: 12px;
  }

  .bottom-list-echarts-li-left-text {
    font-size: 12px;
    line-height: 26px;
    gap: 10px;
  }

  .Color009EA7 {
    font-size: 12px;
  }

  .bottom-list-echarts-head {
    font-size: 14px !important;
  }

  .news-text {
    font-size: 12px;
    margin-bottom: 6px;
  }

  .bottom-list-echarts-li ul {
    padding-top: 6px;
  }

  .MoreCompany {
    font-size: 12px;
    line-height: 16px;
  }

  .icon_sanjiaoLocation{
    bottom: 12px;
    right: 27px;
  }
  
  .tptitleSplit {
    font-size: 20px;
    margin: 20px;
  }
}
</style>
